import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import CustomSelect from '../../components/custom-select/CustomSelect';
import * as RestService from '../../services/eisRest';





  const WrRouteTemplateModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    const [month, setMonth] = useState(null);  
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [wrRouteTemplate, setWrRouteTemplate] = useState([]);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [loadedArticle, setLoadedArticle] = useState();
    const [bomList, setBomList] = useState([]);  
    const [warehouseList, setWarehouseList] = useState([]);
    const [warehouseId, setWarehouseId] = useState(null);

    const handleOpenArticleList = () => {
      setShowArticleModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowArticleModalWithDatatable(show);             
      getDataAboutArticle(id);
    };
  
    const getDataAboutArticle = (id) => {
      RestService.callAnyApi('article/getArticle?id='+id, null)
      .then((data) => {
        setLoadedArticle(data);       
        formik.setFieldValue("articleName",data.name);
      })
      .catch((error) => {
        console.log(error);
      });
    }

    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      if(loadedArticle!=null && loadedArticle.name!=null){        
        formik.setFieldValue("articleName",loadedArticle.name);
      }
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    
    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('workOrder/getWrRouteTemplate?id='+props.selectedRecord, null)
      .then((data) => {          
           setWrRouteTemplate(data);    
           getDataAboutArticle(data.articleId);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=wrRouteTemplate&id='+props.selectedRecord, null).then(
          (data) => {
            setWrRouteTemplate(data.responseObject);  
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    useEffect(() => {
      if(loadedArticle!=null){
        RestService.callAnyApi('workOrder/getBomSelectList?articleId='+loadedArticle.id, null).then((data) => { setBomList(data);}).catch((error) => {});      
      }
    }, [loadedArticle]);


    useEffect(() => {
    
      RestService.callAnyApi('warehouse/getWarehouseOptions', null).then((data) => { setWarehouseList(data);}).catch((error) => {});       
    }, []);

    const save = (url,values) => {
         
  //    wrRouteTemplate.entityId=props.entityId;
    //  wrRouteTemplate.bankId=values.bankId;
    //  wrRouteTemplate.currency=values.currency;
    //  wrRouteTemplate.departmentId=values.departmentId;
     // wrRouteTemplate.iban=values.iban;
      wrRouteTemplate.articleId = loadedArticle.id;
      wrRouteTemplate.name = values.name;
      wrRouteTemplate.bomId = values.bomId;
      wrRouteTemplate.warehouseId = values.warehouseId;
      wrRouteTemplate.description = values.description;
      
     
      RestService.callAnyApi(url, wrRouteTemplate)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        bomId: wrRouteTemplate ? wrRouteTemplate.bomId : '',
        warehouseId:  wrRouteTemplate ? wrRouteTemplate.warehouseId : '',
        name: wrRouteTemplate ? wrRouteTemplate.name : '',
        description: wrRouteTemplate ? wrRouteTemplate.description : ''
      },
      validationSchema: Yup.object({
         name: Yup.string() 
          .nullable()    
          .required(t('general.message.required')),
         bomId: Yup.string() 
          .nullable()    
          .required(t('general.message.required')),
        warehouseId: Yup.string() 
          .nullable()    
          .required(t('general.message.required')),
         articleName: Yup.string()     
           .nullable()
          .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('workOrder/saveWrRouteTemplate',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('workOrder.label.wrRouteTemplate')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                          <div className="row"> 
                                <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.articleName')}</label>
                                    <input type="text" className="form-control" readOnly onClick={handleOpenArticleList} placeholder="" {...formik.getFieldProps('articleName')} />
                                  </div>
                                  {formik.touched.articleName && formik.errors.articleName ? (
                                    <div style={{ color: 'red' }}>{formik.errors.articleName}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row"> 
                                <div className="col-6 col-sm-6 col-lg-6">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.templateName')}</label>
                                    <input type="text" className="form-control"  {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>
                     

                          <div className="row">

                              <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.bom')}</label>                               
                                    <CustomSelect
                                          className='input'
                                          onChange={value=>formik.setFieldValue('bomId',value.value)}
                                          value={formik.values.bomId}
                                          options={bomList}     
                                    />                                
                                  </div>
                                  {formik.touched.bankId && formik.errors.bankId ? (
                                    <div style={{ color: 'red' }}>{formik.errors.bankId}</div>
                                  ) : null} 
                              </div>                 

                          </div>

                          <div className="row">

                                <div className="col-12 col-sm-12 col-lg-12">
                                    <div className="form-group">
                                      <label>{t('article.label.warehouse')}</label>                               
                                      <CustomSelect
                                                   className='input'
                                                   onChange={value=> {formik.setFieldValue('warehouseId',value.value); setWarehouseId(value.value)}}
                                                   value={formik.values.warehouseId}
                                                   options={warehouseList}     
                                           />   	                        
                                    </div>
                                    {formik.touched.warehouseId && formik.errors.warehouseId ? (
                                      <div style={{ color: 'red' }}>{formik.errors.warehouseId}</div>
                                    ) : null} 
                                </div>                 

                                </div>
                      

                          <div className="row">

                              <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                      <label>{t('general.label.description')}</label>
                                      <input type="text" className="form-control" placeholder={t('general.label.description')} {...formik.getFieldProps('description')} />
                                  </div>
                                  {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                              </div>

                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                                                  
                          <Button style={selectedRecord  ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

                <ArticleModalWithDatatable            
                  parentCallback={handleCallback}    
                  modal={showArticleModalWithDatatable}                                
                />
      </>
    );
  };

 export default WrRouteTemplateModal;